import { useState, useEffect } from 'react';

export const useCountdown = (expireInMs: number, resetKey?: string) => {
  const [expirationTime, setExpirationTime] = useState<number | null>(null);
  const [timeLeft, setTimeLeft] = useState(0);

  // Set expiration time when expireInMs changes or when resetKey changes
  useEffect(() => {
    if (expireInMs > 0) {
      const newExpirationTime = Date.now() + expireInMs;
      setExpirationTime(newExpirationTime);
    } else {
      setExpirationTime(null);
    }
  }, [expireInMs, resetKey]);

  // Update countdown every second
  useEffect(() => {
    if (!expirationTime) {
      setTimeLeft(0);
      return;
    }

    const updateTimeLeft = () => {
      const now = Date.now();
      const remaining = Math.max(0, expirationTime - now);
      setTimeLeft(remaining);
    };

    // Update immediately
    updateTimeLeft();

    // Then update every second
    const timer = setInterval(updateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [expirationTime]);

  const formatTime = (timeInMs: number) => {
    const totalSeconds = Math.floor(timeInMs / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    
    if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    }
    return `${seconds}s`;
  };

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    isExpired: timeLeft <= 0
  };
};